module.exports = __webpack_public_path__ + "img/guillaume.7bc3aa0d.jpg";